<template>
  <b-modal id="show-bug-report-modal"
           ref="bugReportModal"
           :cancel-title="$t('Cancel')"
           :ok-title="$t('Send.report')"
           :title="$t('Report.a.bug')"
           cancel-variant="danger"
           @hidden="resetModal"
           @ok="handleOk"
           @show="resetModal">
    <form ref="formReportBug" @submit="handleSubmit">
      <b-form-group
        :invalid-feedback="form.commentaire.invalidFeedback"
        :label="$t('Report.a.bug.label')"
        label-for="reportBug-input">
        <b-form-textarea
          id="reportBug-input"
          v-model="form.commentaire.value"
          :placeholder="$t('Report.a.bug.placeholder')">
        </b-form-textarea>
      </b-form-group>
    </form>
  </b-modal>
</template>

<script>
import api from "../../services/api";
import * as Sentry from "@sentry/vue";

const SENTRY_APP_NAME = "Lamp - Grand public";

export default {
  name: "ShowBugReportModal",

  data() {
    return {
      form: {
        commentaire: {
          value: null,
          state: null,
          invalidFeedback: null
        }
      },
      feedbackSlack: {
        fallback: `Bug signalé par ${this.$store.getters.username}`,
        color: "#d9534f",
        title: `${SENTRY_APP_NAME}\n\n\n\n`,
        title_link: "https://bleu122.sentry.io/projects/srv-lamp/",
        fields: [
          {title: "Utilisateur", value: this.$store.getters.username},
          {title: "Commentaire", value: "ID_unique_du_bug", short: true},
          {title: "ID de l'événement", value: "ID_unique_du_bug", short: true},
          {title: "Environnement", value: process.env.NODE_ENV, short: true}
        ],
        actions: [
          {"type": "button", "text": "Voir l'événement", "url": null}
        ],
        footer: "Sentry",
        ts: new Date().getTime()
      },

    }
  },

  methods: {

    handleOk(bvModalEvt) {
      this.handleSubmit()
    },

    handleSubmit() {
      let eventId = localStorage.getItem('lastEventId')
      if (!eventId) {
        localStorage.setItem('lastEventId', null)
        eventId = localStorage.getItem('lastEventId')
      }
      if (eventId && eventId === "null") {
        eventId = Sentry.captureMessage(`feedback ${this.$store.getters.username} at $${new Date().toISOString()}`, 'info');
      }
      const userFeedback = {
        name: this.$store.getters.username,
        email: this.$store.getters.username,
        comments: this.form.commentaire.value,
        event_id: eventId
      }
      if (eventId) {
        this.captureUserFeedback(userFeedback);
        this.sendFeedBackToSlack(eventId)
      }
      this.resetModal()
    },

    captureUserFeedback(feedback) {
      const data = JSON.stringify(feedback)
      api.post(`${process.env.SERVER_URL}/sentry/captureUserFeedback`, data, {})
        .then(response => {
          console.log("Merci d'avoir signalé un bug")
        }).catch(err => {
        console.log(err)
      })
    },

    showModal() {
      this.$refs.bugReportModal.show();
    },

    resetModal() {
      this.form.commentaire.value = null
      this.form.commentaire.state = null
      this.form.commentaire.invalidFeedback = null
      this.hideModal()
    },

    hideModal() {
      this.$bvModal.hide('show-bug-report-modal')
    },

    sendFeedBackToSlack(eventId) {
      this.feedbackSlack.fields[1].value = this.form.commentaire.value
      this.feedbackSlack.fields[2].value = eventId
      this.feedbackSlack.actions[0].url = `https://bleu122.sentry.io/discover/srv-lamp:${eventId}/`

      api.post("https://hooks.slack.com/services/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", {"attachments": [this.feedbackSlack]}, {})
      localStorage.setItem("lastEventId", null)
    }
  }
}
</script>
<style>
/** pour éviter les 17px de padding qui s'ajoutent en responsive */
#show-bug-report-modal {
  padding-left: 0px !important;
}

#show-bug-report-modal .modal-content,
#show-bug-report-modal .modal-header,
#show-bug-report-modal .modal-body,
#show-bug-report-modal .modal-footer {
  background-color: var(--main-black-dark) !important;
}

#show-bug-report-modal .modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  padding: 0;
  border-bottom: none;
}

#show-bug-report-modal .title-share-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

@media (min-width: 992px) {
  #show-bug-report-modal .title-share-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  #show-bug-report-modal .title-share-container img {
    order: 2;
    align-self: center;
  }

  #show-bug-report-modal .title-share-container {
    text-align: center;
  }
}

#show-bug-report-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}


#show-bug-report-modal .full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}

#show-bug-report-modal .full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #show-bug-report-modal .modal-content {
    display: flex;
    border-radius: 0px;
    overflow: auto;
  }

  #show-bug-report-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #show-bug-report-modal .modal-body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  #show-bug-report-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #show-bug-report-modal .modal-content {
    padding: 0;
    border-radius: 0;
  }

  #show-bug-report-modal .modal-header-content, .title-share-container {
    padding: 10px;
  }
}


#show-bug-report-modal #close-share-button, #show-bug-report-modal .btn-secondary {
  background-color: var(--main-black-dark) !important;
  border-color: var(--main-grey-light) !important;
  color: var(--main-white);
  border-radius: var(--main-border-radius);
  padding: 12px 20px;
  font-size: var(--content-font-size);
}

#show-bug-report-modal #close-share-button:hover:not([disabled]), #show-bug-report-modal .btn-secondary:hover:not([disabled]) {
  background-color: var(--main-black-medium) !important;
}


</style>



// WEBPACK FOOTER //
// src/components/b122/ShowBugReportModal.vue